import React from "react";
import DashboardLayout from "../../layouts/Dashboard";
import DictionaryCRUDTable from "../../components/CRUD/Tables/DictionaryCRUDTable";

const ProtocolTypeList = () => (
    <DashboardLayout>
        <DictionaryCRUDTable
            entityType="protocolType"
            hasCode={true}
            hasDescription={false}
        />
    </DashboardLayout>
);

export default ProtocolTypeList;
